<template>
  <v-tooltip :color="color" bottom :max-width="maxWidth">
    <template v-slot:activator="{ on }">
      <i 
        v-on="on" 
        :class="`${icon} pl-1`"
        :style="{cursor: clickStyle ? 'pointer' : 'default'}"
        @click.stop="$emit('click')"
      ></i>
    </template>
    {{text}}
    <slot></slot>
  </v-tooltip>
</template>

<script>

export default {
  props: {
    text: {type: String},
    icon: {type: String, default: 'fa-regular fa-circle-info'},
    color: {type: String, default: '#192B46'},
    maxWidth: {type: String, default: '250px'},
    clickStyle: {type: Boolean, default: false}
  }
}
</script>